import axiosInstance from "../Utils/axiosInstance";
import { ComissionApi } from "../Constants/api";

export const getComissionsApi = async (params) => {
  try {
    const searchParams = new URLSearchParams(params);

    let response = await axiosInstance.get(
      `${ComissionApi}?${searchParams.toString()}`
    );

    return response.data;
  } catch (error) {
    return error?.response?.data;
    // throw error; // Re-throw error for further handling if needed
  }
};
